import React from "react";
import Home from "./pages/Home";
import AssignmentTile from "./components/Doctolib/AssigmentTile";
import ImageGallery from "./components/AdvancedImageGallery";

function Main() {
  return (
    <>
      <Home />
      <ImageGallery />
      <AssignmentTile />
    </>
  );
}

export default Main;
